import { render, staticRenderFns } from "./fsh-rapid-test_h5.vue?vue&type=template&id=482de8e6&scoped=true&"
import script from "./fsh-rapid-test_h5.vue?vue&type=script&lang=js&"
export * from "./fsh-rapid-test_h5.vue?vue&type=script&lang=js&"
import style0 from "./fsh-rapid-test_h5.vue?vue&type=style&index=0&id=482de8e6&scoped=true&lang=less&"
import style1 from "./fsh-rapid-test_h5.vue?vue&type=style&index=1&id=482de8e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482de8e6",
  null
  
)

export default component.exports